import { Injectable, QueryList } from '@angular/core';
import { Subject } from 'rxjs';

import { ItemComponent } from './item.component';

/**
 * Wizard service lets you to reach the options of the wizard on-the-fly.
 */
@Injectable({
  providedIn: 'root',
})
export class WizardService {
  /**
   * Currently active step
   */
  public active: number;
  /**
   * Array of the steps which have warning case
   */
  public warningSteps: number[] = [];
  /**
   * Vertical option of the wizard.
   */
  public isVertical = new Subject<boolean>();

  /**
   * The active index subject for the subscription of the active index.
   */
  public activeIndex = new Subject<{ id?: string; value: number; }>();

  /**
   * List of steps as publicly
   */
  public steps:QueryList<ItemComponent>;

  /**
   * Boolean for step is last step or not
   */
  public isLast:boolean;

  gotoNextStep(id?: string) {
    const nextStep = Math.floor(this.active + 1);
    if(nextStep <= this.steps.length) {
      this.activeIndex.next({ id, value: nextStep});
    }
  }

  gotoPrevStep(id?: string) {
    const prevStep = Math.floor(this.active - 1);
    if(prevStep >= 0) {
      this.activeIndex.next({ id, value: prevStep});
    }
  }
}
